import 'view/css/report.css';

import moment from 'moment';
import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';

import API from 'service/api';
import Util from 'service/util';

import Loading from 'component/Loading';
import Protected from 'component/Protected';
import PopMessage from 'component/pop-msg/PopMessage';

import SalaryTable from 'component/report/SalaryTable';
import SearchableList from 'component/dropdown/SearchableList';

class Salary
{
  constructor(o)
  {
    delete o.salary_total;
    Object.assign(this, o);
  }
  get salary_total() {
    return this.salary_1 + this.salary_2 + this.salary_3;
    // - this.leave_deduct_1 - this.leave_deduct_2 - this.leave_deduct_3
  }
}

class StaffSalaryView extends React.Component
{
  constructor(props)
  {
    super(props);
    this.state = {
       sel_staff: null
      ,sel_ix: parseInt(moment().add(-1, 'month').format('yyyyMM'), 10)
      ,loading: true
      ,exporting: false
    };
    this.staff = new Map();
    this.data  = {};
    this.ixstf = {};

    this.setStaff = this.setStaff.bind(this);
  }
  componentDidMount()
  {
    API.getStaffList().then(staff => {
      this.staff = staff.reduce((r,s) => { r.set(s.id, s); return r; }, new Map());
      this.setMonth(this.state.sel_ix);
    });
  }

  exportAllXls()
  {
    const ix = this.state.sel_ix;
    this.setState({exporting: true});

    API.exportStaffSalary(ix).then(resp => {
      const ix_date = moment().format('YYYYMMDD');
      Util.download(resp, `判工薪資_${ix}_${ix_date}.zip`);
      this.setState({exporting: false});
    });
  }

  exportOneXls()
  {
    // skip when no staff selected
    if (!this.state.sel_staff) return;

    // prepare data
    const ix  = this.state.sel_ix;
    const uid = this.state.sel_staff.id;
    const staff_name = this.state.sel_staff.display_name;
    this.setState({exporting: true});

    // execute
    API.exportStaffSalary(ix, uid).then(resp => {
      const ix_date = moment().format('YYYYMMDD');
      Util.download(resp, `判工薪資_${ix}_${staff_name}_${ix_date}.xlsx`);
      this.setState({exporting: false});
    });
  }

  setMonth(sel_ix)
  {
    // check loaded
    if (this.data[sel_ix]) {
      this.setState({sel_ix});
      return;
    }

    // call load
    this.setState({sel_ix, loading: true});
    API.getStaffSalary(sel_ix).then(resp => {
      let sel_staff = false;
      if (resp.success)
      {
        const M = this.data[sel_ix]  = new Map();
        const S = this.ixstf[sel_ix] = [];
        Object.keys(resp.msg).forEach(k => {
          // convert to salary object to provide property/functions
          let sal_obj = resp.msg[k].salary;
          if (sal_obj) {
            Object.keys(sal_obj).forEach(loc => {
              sal_obj[loc] = new Salary(sal_obj[loc]);
            });
          }

          M.set(parseInt(k,10), resp.msg[k]);
          let s = this.staff.get(resp.msg[k].worker.id);
          if (s) S.push(s);
        });
        sel_staff = S[0];
      } else {
        PopMessage.show(resp.msg, '讀取失敗', 'danger');
      }
      this.setState({sel_staff, loading: false});
    });
  }

  setStaff(sel_staff)
  {
    this.setState({sel_staff});
  }

  render()
  {
    const data = this.data[this.state.sel_ix]?.get(this.state.sel_staff?.id);
    return (<>
      <h1>報表 - 員工薪資</h1>
      <p className="message blue">員工前六個月的薪酬。</p>
      <div className="action-panel">
        <div className="row search-bar">
          <label className="field-row">
            <strong>月份</strong>
            <select value={this.state.sel_ix} onChange={e=>this.setMonth(parseInt(e.target.value ,10))}>
              { [-1,0,1,2,3,4,5,6].map(i => moment().add(-i, 'month')).map((x, i) =>
                <option key={i} value={x.format('yyyyMM')}>{ x.format('yyyy年 M月') }</option>
              )}
            </select>
          </label>
          { !!this.state.sel_staff &&
            <label className="field-row">
              <strong>員工</strong>
              <SearchableList value={this.state.sel_staff} onChange={this.setStaff}
                items={this.ixstf[this.state.sel_ix]}
                filter={(w,v) => -1<`${w.id}||${w.worker_code}||${w.display_name}`.toUpperCase().indexOf(v.toUpperCase())}
                getTitle={w => w.id}
                getDesc={w => w.display_name}
              />
            </label>
          }
        </div>
        <div className="button-group">
          <Protected allow={['ADMIN','OPERATOR','VIEWER_SU','VIEWER_NIGHT']}>
            { !this.state.loading && !!this.state.sel_staff &&
              <button className="btn dark-green btn-export" disabled={this.state.exporting}
                onClick={e=>this.exportOneXls()}>
                <FontAwesomeIcon icon={faFileExcel} />
                <span> 匯出</span>
              </button>
            }
          </Protected>
          <Protected allow={['ADMIN','OPERATOR','VIEWER_SU']}>
            { !this.state.loading &&
              <button className="btn dark-green btn-export" disabled={this.state.exporting}
                onClick={e=>this.exportAllXls()}>
                <FontAwesomeIcon icon={faFileExcel} />
                <span> 全部匯出</span>
              </button>
            }
          </Protected>
        </div>
      </div>
      <div className="salary-page">
        { this.state.loading
            ?<Loading />
            :<SalaryTable data={data} staff={this.state.sel_staff?.id} />
        }
      </div>
    </>);
  } // render

}

export default StaffSalaryView;